import { css, cx } from "@emotion/css"
import { Box } from "@material-ui/core"
import { ReactNode } from "react"

type HeaderProps = {
  title: string
  extraTitle?: string
  details?: ReactNode
}
export function CustomHeader(props: HeaderProps) {
  const { title, extraTitle, details } = props
  return (
    <div className={styles.root}>
      <Box display="flex" flexDirection="row" alignItems="baseline">
        <div className={cx("HeadingH1Bold", styles.tittle)}>{title}</div>
        <div
          className={cx("HeadingH1Bold", styles.tittle)}
          style={{ fontSize: "22px", fontWeight: 400, paddingLeft: 8 }}
        >
          {extraTitle}
        </div>
      </Box>

      <div className={cx("HeadingH1Bold", styles.details)}>{details}</div>
    </div>
  )
}
const styles = {
  root: css`
    display: flex;
    flex-direction: column;
  `,
  tittle: css`
    text-align: left;
    color: var(--white);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 600px;
  `,
  details: css`
    font-size: 10px;
    letter-spacing: 1.5px;
    white-space: nowrap;
    font-weight: normal;
    text-align: left;
    color: var(--white);
    text-transform: uppercase;
  `,
}
